import { main } from './main'

import '../scss/style.scss'

main();